/**
 * `<SweepBanner>` — the big one-line banner that sweeps across the screen: combat's side-change
 * banner ("LANCERS' TURN", `TurnBanner.tsx`) and the FULL REPAIR flourish (`DirectiveOverlay`'s
 * `full-repair` FX). The look lives in `index.css` (`.lvtt-sweep`): a band of light whose left and
 * right edges fade to transparent, a sheen travelling across it, and a slide-in from
 * `--sweep-from`. The caller's class positions it and sets its colours (`--sweep-bg`).
 */
export function SweepBanner({ text, sub, className, testId }: { text: string; sub?: string; className: string; testId?: string }): React.JSX.Element {
  return (
    <div className={`lvtt-sweep ${className}`} role="status" data-testid={testId}>
      <span className="lvtt-sweep-text">{text}</span>
      {sub && <span className="lvtt-sweep-sub">{sub}</span>}
    </div>
  );
}
